import { UserCircleIcon } from '@heroicons/react/24/solid';
import { useAccountType } from '@src/contexts';
import { Select } from 'antd';

export const AccountTypeSelector = () => {
    const { accountType, setAccountType } = useAccountType();

    const options = [
        {
            label: <OptionLabel text="My account" />,
            value: 'myAccount',
        },
        {
            label: <OptionLabel text="Sub-Accounts" />,
            value: 'subAccounts',
        },
    ];

    return (
        <Select
            size="large"
            onChange={(value) =>
                setAccountType(value as 'myAccount' | 'subAccounts')
            }
            defaultValue={accountType}
            options={options}
            className="w-48"
        />
    );
};

const OptionLabel = ({ text }: { text: string }) => (
    <div className="flex gap-2 items-center">
        <div className="rounded-2xl h-8 w-8 border-4 text-white flex items-center justify-center bg-primary border-primary">
            <UserCircleIcon width={24} height={24} />
        </div>
        <span className="text-R-16 text-textPrimary">{text}</span>
    </div>
);
